
export const countries = [
  { id: 'af', name: 'Afghanistan', description: 'Explore airports in Afghanistan' },
  { id: 'al', name: 'Albania', description: 'Discover Albanian airports' },
  { id: 'dz', name: 'Algeria', description: 'Find airports in Algeria' },
  { id: 'ad', name: 'Andorra', description: 'View Andorran airports' },
  { id: 'ao', name: 'Angola', description: 'Explore Angolan airports' },
  { id: 'ar', name: 'Argentina', description: 'Discover Argentinian airports' },
  { id: 'am', name: 'Armenia', description: 'Find airports in Armenia' },
  { id: 'au', name: 'Australia', description: 'Explore Australian airports' },
  { id: 'at', name: 'Austria', description: 'Discover Austrian airports' },
  { id: 'az', name: 'Azerbaijan', description: 'Find airports in Azerbaijan' },
  { id: 'bs', name: 'Bahamas', description: 'View Bahamian airports' },
  { id: 'bh', name: 'Bahrain', description: 'Explore airports in Bahrain' },
  { id: 'bd', name: 'Bangladesh', description: 'Discover Bangladeshi airports' },
  { id: 'by', name: 'Belarus', description: 'Find airports in Belarus' },
  { id: 'be', name: 'Belgium', description: 'View Belgian airports' },
  { id: 'br', name: 'Brazil', description: 'Explore Brazilian airports' },
  { id: 'bg', name: 'Bulgaria', description: 'Discover Bulgarian airports' },
  { id: 'kh', name: 'Cambodia', description: 'Find airports in Cambodia' },
  { id: 'cm', name: 'Cameroon', description: 'View Cameroonian airports' },
  { id: 'ca', name: 'Canada', description: 'Explore Canadian airports' },
  { id: 'cl', name: 'Chile', description: 'Discover Chilean airports' },
  { id: 'cn', name: 'China', description: 'Find airports in China' },
  { id: 'co', name: 'Colombia', description: 'View Colombian airports' },
  { id: 'cr', name: 'Costa Rica', description: 'Explore Costa Rican airports' },
  { id: 'hr', name: 'Croatia', description: 'Discover Croatian airports' },
  { id: 'cu', name: 'Cuba', description: 'Find airports in Cuba' },
  { id: 'cy', name: 'Cyprus', description: 'View Cypriot airports' },
  { id: 'cz', name: 'Czech Republic', description: 'Explore Czech airports' },
  { id: 'dk', name: 'Denmark', description: 'Discover Danish airports' },
  { id: 'dm', name: 'Dominica', description: 'Find airports in Dominica' },
  { id: 'ec', name: 'Ecuador', description: 'View Ecuadorian airports' },
  { id: 'eg', name: 'Egypt', description: 'Explore Egyptian airports' },
  { id: 'sv', name: 'El Salvador', description: 'Discover Salvadoran airports' },
  { id: 'ee', name: 'Estonia', description: 'Find airports in Estonia' },
  { id: 'et', name: 'Ethiopia', description: 'View Ethiopian airports' },
  { id: 'fj', name: 'Fiji', description: 'Explore Fijian airports' },
  { id: 'fi', name: 'Finland', description: 'Discover Finnish airports' },
  { id: 'fr', name: 'France', description: 'Find airports in France' },
  { id: 'de', name: 'Germany', description: 'View German airports' },
  { id: 'gr', name: 'Greece', description: 'Explore Greek airports' },
  { id: 'gl', name: 'Greenland', description: 'Discover Greenlandic airports' },
  { id: 'gt', name: 'Guatemala', description: 'Find airports in Guatemala' },
  { id: 'hn', name: 'Honduras', description: 'View Honduran airports' },
  { id: 'hk', name: 'Hong Kong', description: 'Explore Hong Kong airports' },
  { id: 'hu', name: 'Hungary', description: 'Discover Hungarian airports' },
  { id: 'is', name: 'Iceland', description: 'Find airports in Iceland' },
  { id: 'in', name: 'India', description: 'View Indian airports' },
  { id: 'id', name: 'Indonesia', description: 'Explore Indonesian airports' },
  { id: 'ir', name: 'Iran', description: 'Discover Iranian airports' },
  { id: 'iq', name: 'Iraq', description: 'Find airports in Iraq' },
  { id: 'ie', name: 'Ireland', description: 'View Irish airports' },
  { id: 'il', name: 'Israel', description: 'Explore Israeli airports' },
  { id: 'it', name: 'Italy', description: 'Discover Italian airports' },
  { id: 'jm', name: 'Jamaica', description: 'Find airports in Jamaica' },
  { id: 'jp', name: 'Japan', description: 'View Japanese airports' },
  { id: 'jo', name: 'Jordan', description: 'Explore Jordanian airports' },
  { id: 'kz', name: 'Kazakhstan', description: 'Discover Kazakh airports' },
  { id: 'ke', name: 'Kenya', description: 'Find airports in Kenya' },
  { id: 'kr', name: 'South Korea', description: 'View South Korean airports' },
  { id: 'kw', name: 'Kuwait', description: 'Explore Kuwaiti airports' },
  { id: 'kg', name: 'Kyrgyzstan', description: 'Discover Kyrgyz airports' },
  { id: 'la', name: 'Laos', description: 'Find airports in Laos' },
  { id: 'lv', name: 'Latvia', description: 'View Latvian airports' },
  { id: 'lb', name: 'Lebanon', description: 'Explore Lebanese airports' },
  { id: 'lt', name: 'Lithuania', description: 'Discover Lithuanian airports' },
  { id: 'lu', name: 'Luxembourg', description: 'Find airports in Luxembourg' },
  { id: 'mo', name: 'Macau', description: 'View Macanese airports' },
  { id: 'my', name: 'Malaysia', description: 'Explore Malaysian airports' },
  { id: 'mv', name: 'Maldives', description: 'Discover Maldivian airports' },
  { id: 'mt', name: 'Malta', description: 'Find airports in Malta' },
  { id: 'mx', name: 'Mexico', description: 'View Mexican airports' },
  { id: 'md', name: 'Moldova', description: 'Explore Moldovan airports' },
  { id: 'mc', name: 'Monaco', description: 'Discover Monacan airports' },
  { id: 'mn', name: 'Mongolia', description: 'Find airports in Mongolia' },
  { id: 'ma', name: 'Morocco', description: 'View Moroccan airports' },
  { id: 'mm', name: 'Myanmar', description: 'Explore Myanmar airports' },
  { id: 'np', name: 'Nepal', description: 'Discover Nepalese airports' },
  { id: 'nl', name: 'Netherlands', description: 'Find airports in the Netherlands' },
  { id: 'nz', name: 'New Zealand', description: 'View New Zealand airports' },
  { id: 'ni', name: 'Nicaragua', description: 'Explore Nicaraguan airports' },
  { id: 'ng', name: 'Nigeria', description: 'Discover Nigerian airports' },
  { id: 'no', name: 'Norway', description: 'Find airports in Norway' },
  { id: 'om', name: 'Oman', description: 'View Omani airports' },
  { id: 'pk', name: 'Pakistan', description: 'Explore Pakistani airports' },
  { id: 'pa', name: 'Panama', description: 'Discover Panamanian airports' },
  { id: 'pg', name: 'Papua New Guinea', description: 'Find airports in Papua New Guinea' },
  { id: 'py', name: 'Paraguay', description: 'View Paraguayan airports' },
  { id: 'pe', name: 'Peru', description: 'Explore Peruvian airports' },
  { id: 'ph', name: 'Philippines', description: 'Discover Filipino airports' },
  { id: 'pl', name: 'Poland', description: 'Find airports in Poland' },
  { id: 'pt', name: 'Portugal', description: 'View Portuguese airports' },
  { id: 'qa', name: 'Qatar', description: 'Explore Qatari airports' },
  { id: 'ro', name: 'Romania', description: 'Discover Romanian airports' },
  { id: 'ru', name: 'Russia', description: 'Find airports in Russia' },
  { id: 'sa', name: 'Saudi Arabia', description: 'View Saudi Arabian airports' },
  { id: 'rs', name: 'Serbia', description: 'Explore Serbian airports' },
  { id: 'sg', name: 'Singapore', description: 'Discover Singaporean airports' },
  { id: 'sk', name: 'Slovakia', description: 'Find airports in Slovakia' },
  { id: 'si', name: 'Slovenia', description: 'View Slovenian airports' },
  { id: 'za', name: 'South Africa', description: 'Explore South African airports' },
  { id: 'es', name: 'Spain', description: 'Discover Spanish airports' },
  { id: 'lk', name: 'Sri Lanka', description: 'Find airports in Sri Lanka' },
  { id: 'se', name: 'Sweden', description: 'View Swedish airports' },
  { id: 'ch', name: 'Switzerland', description: 'Explore Swiss airports' },
  { id: 'tw', name: 'Taiwan', description: 'Discover Taiwanese airports' },
  { id: 'tj', name: 'Tajikistan', description: 'Find airports in Tajikistan' },
  { id: 'th', name: 'Thailand', description: 'View Thai airports' },
  { id: 'tt', name: 'Trinidad and Tobago', description: 'Explore Trinidad and Tobago airports' },
  { id: 'tn', name: 'Tunisia', description: 'Discover Tunisian airports' },
  { id: 'tr', name: 'Turkey', description: 'Find airports in Turkey' },
  { id: 'tm', name: 'Turkmenistan', description: 'View Turkmen airports' },
  { id: 'ae', name: 'UAE', description: 'Explore Emirati airports' },
  { id: 'gb', name: 'United Kingdom', description: 'View UK airports' },
  { id: 'us', name: 'United States', description: 'Explore US airports' },
  { id: 'uy', name: 'Uruguay', description: 'Discover Uruguayan airports' },
  { id: 'uz', name: 'Uzbekistan', description: 'Find airports in Uzbekistan' },
  { id: 've', name: 'Venezuela', description: 'View Venezuelan airports' },
  { id: 'vn', name: 'Vietnam', description: 'Explore Vietnamese airports' },
  { id: 'ye', name: 'Yemen', description: 'Discover Yemeni airports' },
  { id: 'zm', name: 'Zambia', description: 'Find airports in Zambia' },
  { id: 'zw', name: 'Zimbabwe', description: 'View Zimbabwean airports' },
] as const;

export type Country = typeof countries[number];
